// "Restore N tabs" on the Classic start page (and in Re:Vault OS's browser window, which is the
// same page). The island draws its own from the same offer (island/main.js).
import { restoreOffer } from "./session-store.js";
import { restoreLabel } from "../shared/session-snap.js";
import { announce } from "./announce.js";
import { $ } from "./dom.js";

const RESTORE_SVG = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.2 8 a4.8 4.8 0 1 0 1.4-3.4"></path><polyline points="2.4,2.6 4.6,4.7 7,4"></polyline></svg>';
const X_SVG = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><line x1="4" y1="4" x2="10" y2="10"/><line x1="10" y1="4" x2="4" y2="10"/></svg>';

export function initRestoreOffer() {
	const el = $("rv-restore");
	if (!el) return;
	const draw = () => {
		const o = restoreOffer.get();
		const had = el.contains(document.activeElement);
		el.textContent = "";
		if (!o) {
			el.hidden = true;
			delete document.documentElement.dataset.restore;
			if (had) { const q = $("rv-startsearch-input"); if (q) q.focus({ preventScroll: true }); }
			return;
		}
		const go = document.createElement("button");
		go.type = "button";
		go.className = "rv-restore-go";
		go.innerHTML = RESTORE_SVG;
		go.append(restoreLabel(o.count));
		go.addEventListener("click", () => {
			restoreOffer.accept();
			announce(restoreLabel(o.count).replace("Restore", "Restored"));
			const c = $("rv-content");
			if (c) c.focus({ preventScroll: true });
		});
		const line = document.createElement("span");
		line.className = "rv-restore-line";
		line.textContent = o.line ? "from last time: " + o.line : "from last time";
		const x = document.createElement("button");
		x.type = "button";
		x.className = "rv-restore-x";
		x.innerHTML = X_SVG;
		x.setAttribute("aria-label", "No thanks, don't restore");
		x.title = "No thanks";
		x.addEventListener("click", () => { restoreOffer.dismiss(); announce("Your last tabs won't be restored."); });
		el.append(go, line, x);
		el.hidden = false;
		document.documentElement.dataset.restore = "1";
	};
	restoreOffer.watch(draw);
	draw();
}
